import {useSelector} from "react-redux";
import LabeledSelect from "../../../components/selects/LabeledSelect";

const FeaturesSelect = ({

                          className,
                          exclude = [],
                          onFeatureSelect,
                          ...props
                        }) => {

  const {init, data} = useSelector((state => state.manageUser.features));

  const _data = data.filter((f) => !exclude.some((e) => e.id === f.id));


  return (

    <LabeledSelect label="Select features to give access to the user."
                   value={"value"}
                   options={_data}
                   loading={!init}
                   isDisabled={!init}
                   getOptionValue={(option) => option.id}
                   getOptionLabel={(option) => option.name}
                   onChange={onFeatureSelect}
                   emptyMsg={"Empty"} {...props} />
  );
};


export default FeaturesSelect;

